import React from 'react'
import TwitterShareIcon from '../../Icons/TwitterShareIcon';
import LinkedinShareIcon from '../../Icons/LinkedinShareIcon';
import FacebookShareIcon from '../../Icons/FacebookShareIcon';
import CopyLinkIcon from '../../Icons/CopyLinkIcon';

const ArticleV2SocialHeading = ({data}) => {
    return (
        <div className='flex social-heading'>
            <div className='credits'>
                {data?.author ? <h5>Words by: {data?.author}</h5> : null}
                {data?.photography ? <h5>Photography by: {data?.photography}</h5> : null}
                {data?.illustration ? <h5>Illustration by: {data?.illustration}</h5> : null}
            </div>

            <div className='share-links'>
                <h5>Share:</h5>
                <TwitterShareIcon/>
                <LinkedinShareIcon/>
                <FacebookShareIcon/>
                <CopyLinkIcon/>
            </div>

            <style jsx>{`
                .social-heading {
                    justify-content: space-between;
                    padding: 20px 40px;
                    background: #f4f4f4;
                    font-size: 24px;
                    align-items: center;
                }
                .button {
                    height: 50px;
                    width: 50px;
                    border-radius: 50%;
                    background: #dfdfdf;
                    cursor: pointer;
                }
                img {
                    max-height: 70%;
                    max-width: 70%;
                }
                h5 {
                    font-weight: 300;
                }

                .credits h5 {
                    margin-bottom: 6px;
                }

                .credits h5:last-child {
                    margin-bottom: 0;
                }
                
                .share-links {
                    display: grid;
                    grid-gap: 6px;
                    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
                    align-items: center;
                    justify-items: center;
                }

                @media (max-width: 769px), (pointer: coarse) {
                    .social-heading {
                        padding: 20px;
                    }

                    .credits h5 {
                        font-size: 16px;

                    }

                    .share-links {
                        display: none;
                    }
                }
            `}</style>
        </div>
    )
}

export default ArticleV2SocialHeading;